import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';
import { Toaster } from 'sonner';

import { setSessionExpiredHandler } from '@/lib/api-client';
import { httpStatus } from '@/lib/api-errors';
import { createAppRouter } from '@/router';

// Pas de persistance du cache : données inter-tenants, rien ne doit rester dans le navigateur
const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: (count, err) => httpStatus(err) !== 401 && count < 1,
        refetchOnWindowFocus: false,
      },
    },
  });

export const App = ({ router: injected }: { router?: ReturnType<typeof createAppRouter> }) => {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => {
    const r = injected ?? createAppRouter();
    // Branché avant la première requête : tout 401 hors login/MFA renvoie au login « Session expirée »
    setSessionExpiredHandler(() => {
      queryClient.clear();
      void r.navigate({ to: '/login', search: { reason: 'expired' }, replace: true });
    });
    return r;
  });
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* En bas : en haut à droite, le toast masquerait l'admin connecté et le bouton Déconnexion de l'en-tête */}
      <Toaster position="bottom-right" richColors closeButton />
    </QueryClientProvider>
  );
};
